import { Amplify, Auth } from 'aws-amplify'
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.min.js";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import awsconfig from './aws-exports.prod.js';
import awsconfig from './aws-exports.js';
// import awsconfig from './aws-config.js';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const { REACT_APP_AWS_REDIRECT_SIGNIN_URL, REACT_APP_AWS_REDIRECT_SIGNOUT_URL } = process.env;
Amplify.configure(awsconfig);

//prod: hrcentralized.auth.ap-southeast-1.amazoncognito.com
//dev : hrcentralizedapp-dev.auth.ap-southeast-1.amazoncognito.com

const oauth = {
    domain: 'hrcentralized.auth.ap-southeast-1.amazoncognito.com',
    scope: [
        'aws.cognito.signin.user.admin',
        'email',
        'openid',
        'phone',
        'profile',
    ],
    redirectSignIn: REACT_APP_AWS_REDIRECT_SIGNIN_URL,
    redirectSignOut: REACT_APP_AWS_REDIRECT_SIGNOUT_URL,
    responseType: 'code',
};

Auth.configure({
    oauth: oauth,
});

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
